<template>
  <div class="TopPreview">
    <form-text-box
      :column="column"
      :dataList="dataList"
      :model="model"
    />
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    model: {
      type: Object,
      default: () => {},
    },
    column: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.TopPreview {
  margin-bottom: 16px;
  padding-top: 16px;
  border: 1px solid #DCDFE6;
}
</style>
